"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconActionDropDown = _interopRequireDefault(require("../../Icons/IconActionDropDown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HeaderCell = function HeaderCell(_ref) {
  var width = _ref.width,
      className = _ref.className,
      children = _ref.children,
      isTitle = _ref.isTitle,
      onClick = _ref.onClick,
      active = _ref.active,
      order = _ref.order,
      _ref$orderEnabled = _ref.orderEnabled,
      orderEnabled = _ref$orderEnabled === void 0 ? true : _ref$orderEnabled,
      otherProps = _objectWithoutProperties(_ref, ["width", "className", "children", "isTitle", "onClick", "active", "order", "orderEnabled"]);

  return /*#__PURE__*/_react.default.createElement(Th, _extends({
    width: width,
    isTitle: isTitle,
    className: className,
    onClick: onClick,
    active: active,
    order: order
  }, otherProps), /*#__PURE__*/_react.default.createElement(ThWrapper, {
    orderEnabled: orderEnabled
  }, children, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    active: active,
    order: order
  }, /*#__PURE__*/_react.default.createElement(_IconActionDropDown.default, {
    color: "#505050"
  }))));
};

var Th = _styledComponents.default.th.withConfig({
  displayName: "Th"
})(["padding-bottom:1.3rem;width:", ";font-weight:", ";font-size:", ";color:", ";vertical-align:middle;"], function (props) {
  return props.width;
}, function (_ref2) {
  var isTitle = _ref2.isTitle,
      active = _ref2.active;
  return isTitle || active ? '700' : '400';
}, function (props) {
  return props.isTitle ? "1.6rem" : "1.3rem";
}, function (_ref3) {
  var isTitle = _ref3.isTitle,
      active = _ref3.active;
  return isTitle || active ? '#5B5550' : '#A29C95';
});

var ThWrapper = _styledComponents.default.div.withConfig({
  displayName: "ThWrapper"
})(["display:flex;align-items:center;cursor:", ";"], function (_ref4) {
  var orderEnabled = _ref4.orderEnabled;
  return orderEnabled ? 'pointer' : 'auto';
});

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconWrapper"
})(["display:", ";transform:rotate( ", " );height:1.6rem;width:1.6rem;justify-content:center;align-items:center;margin-left:4px;"], function (_ref5) {
  var active = _ref5.active;
  return active ? 'flex' : 'none';
}, function (_ref6) {
  var active = _ref6.active,
      order = _ref6.order;
  return active && order === 'ascending' ? '180deg' : '';
});

HeaderCell.defaultProps = {
  otherProps: {},
  isTitle: false,
  width: 'unset',
  onClick: function onClick() {}
};
HeaderCell.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  children: _propTypes.node,

  /** The width of the tableCell element */
  width: _propTypes.string,

  /** Applies isTitle styling to the cell */
  isTitle: _propTypes.bool,
  onClick: _propTypes.func,
  order: _propTypes.string,
  active: _propTypes.bool,
  orderEnabled: _propTypes.bool
};
var _default = HeaderCell;
exports.default = _default;